




















import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

@Component
export default class ChoosePeriodCard extends Vue {
  @Prop() readonly periods!: Array<number>

  @VModel({ type: Number })

  selectedPeriod!: Array<number>

  get computedPeriods(): Array<number> {
    return this.periods.sort((a: number, b: number): number => a - b)
  }
}
